var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPlankton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 158 79.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#141529;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 158,
    height: 79.24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_711-2",
    "data-name": "Grupo 711-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_894",
    "data-name": "Trazado 894",
    className: "cls-3",
    d: "M0,79.09V58.86H8.44a5.53,5.53,0,0,1,2.46.55,6.26,6.26,0,0,1,1.94,1.48A7.1,7.1,0,0,1,14.11,63a6.26,6.26,0,0,1,.45,2.35,6.93,6.93,0,0,1-.42,2.42,6.7,6.7,0,0,1-1.22,2.08A6,6,0,0,1,11,71.29a5.53,5.53,0,0,1-2.43.54h-6v7.26Zm2.57-9.55h5.9a3.09,3.09,0,0,0,1.43-.32,3.24,3.24,0,0,0,1.1-.91A4.45,4.45,0,0,0,11.72,67,4.94,4.94,0,0,0,12,65.33a4.49,4.49,0,0,0-1.1-3,3.41,3.41,0,0,0-1.17-.89,3.26,3.26,0,0,0-1.41-.31H2.57Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_895",
    "data-name": "Trazado 895",
    className: "cls-3",
    d: "M17.76,79.09V58.86h2.56v18H31.61v2.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_896",
    "data-name": "Trazado 896",
    className: "cls-3",
    d: "M40.56,58.86h2.16L51,79.09H48.25l-2.39-5.93H37.37L35,79.09H32.26Zm4.73,12.31-3.65-9.35-3.76,9.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_897",
    "data-name": "Trazado 897",
    className: "cls-3",
    d: "M56.26,63.65V79.09H53.69V58.86h2L68.23,74.62V58.88H70.8V79.09H68.63Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_898",
    "data-name": "Trazado 898",
    className: "cls-3",
    d: "M75.64,79.09V58.88h2.57V70.06l10.43-11.2H91.4l-8.12,8.92,8.58,11.31H89.07l-7.36-9.83-3.5,3.65v6.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_899",
    "data-name": "Trazado 899",
    className: "cls-3",
    d: "M108.82,61.14h-7v18H99.27v-18h-7V58.86h16.53Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_900",
    "data-name": "Trazado 900",
    className: "cls-3",
    d: "M119.34,79.24a8.71,8.71,0,0,1-3.89-.87,9.58,9.58,0,0,1-3-2.31,10.63,10.63,0,0,1-1.94-3.29,10.94,10.94,0,0,1-.68-3.79,10.48,10.48,0,0,1,.72-3.88,10.74,10.74,0,0,1,2-3.28,9.62,9.62,0,0,1,3-2.26,8.65,8.65,0,0,1,3.8-.85,8.54,8.54,0,0,1,3.88.9,10,10,0,0,1,3,2.36,10.94,10.94,0,0,1,2.63,7,10.78,10.78,0,0,1-2.73,7.14,9.66,9.66,0,0,1-3,2.25,8.79,8.79,0,0,1-3.81.84M112.41,69a8.68,8.68,0,0,0,.5,3,8.18,8.18,0,0,0,1.41,2.55,6.79,6.79,0,0,0,2.19,1.76,6.15,6.15,0,0,0,2.85.66,5.9,5.9,0,0,0,2.91-.7,7.07,7.07,0,0,0,2.18-1.82,8.33,8.33,0,0,0,1.37-2.56,9,9,0,0,0,.47-2.87,9.14,9.14,0,0,0-.5-3,8,8,0,0,0-1.43-2.54,7.15,7.15,0,0,0-2.19-1.75,6.4,6.4,0,0,0-5.72,0,6.87,6.87,0,0,0-2.18,1.8,8.09,8.09,0,0,0-1.38,2.53,9,9,0,0,0-.48,2.91",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_901",
    "data-name": "Trazado 901",
    className: "cls-3",
    d: "M135,63.65V79.09h-2.56V58.86h2L147,74.62V58.88h2.56V79.09h-2.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_902",
    "data-name": "Trazado 902",
    className: "cls-3",
    d: "M151.2,62.27a3.4,3.4,0,1,1,3.4,3.4h0a3.4,3.4,0,0,1-3.4-3.4m.69,0a2.71,2.71,0,1,0,2.71-2.71,2.7,2.7,0,0,0-2.71,2.71",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_903",
    "data-name": "Trazado 903",
    className: "cls-3",
    d: "M153.11,64V60.41h1.47a2,2,0,0,1,.69.1.8.8,0,0,1,.4.25.77.77,0,0,1,.19.43,1.23,1.23,0,0,1,0,.54.82.82,0,0,1-.47.51l-.15.06.05,0a.75.75,0,0,1,.36.27,3.21,3.21,0,0,1,.19.31l.51,1,0,0h-1a0,0,0,0,1,0,0l-.45-.9a1.07,1.07,0,0,0-.13-.21.46.46,0,0,0-.35-.2H154V64Zm.92-2h.43l.2,0a.33.33,0,0,0,.27-.27.55.55,0,0,0,0-.31.32.32,0,0,0-.23-.27l-.12,0H154Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_904",
    "data-name": "Trazado 904",
    className: "cls-3",
    d: "M131.38,45.58h0l-.23-.32-.17-.34a12.06,12.06,0,0,1-7.67-.14C115.76,42,111.34,31.3,107.07,21,102.93,11,99,1.51,92.45.17c-2.69-.55-5.56.25-8.78,2.46C79,6,74.72,13.09,70.55,20c-5,8.24-10.14,16.75-15.1,17.1-3.33.25-6.77-3.11-10.4-6.66-6.07-5.94-13.62-13.32-24.87-8l.22.27-.24.12.23.25-.25.14.24.23-.26.15.25.22L20.1,24l.67.53C23.32,22.69,25.7,22,28,22.33c6.13.93,11.1,9.27,15.48,16.64s8.26,13.89,13.13,13.89H57c6.93-.4,9.49-7.38,12.46-15.46,2.1-5.73,4.49-12.22,8.81-16.86,3.84-4,7.27-5.77,10.48-5.57,5.75.36,10.31,7.18,15.13,14.39,5.1,7.64,10.38,15.54,18,17.29a15.45,15.45,0,0,0,9.55-1h0M43.88,35c4.25,5.68,7.91,10.59,12.38,10.31,6.23-.4,10.12-8.3,14.23-16.66,3.13-6.36,6.36-12.94,10.8-16.83,3.34-2.92,6.29-4.18,9-3.84,5.82.73,10,8.72,14.5,17.18a98.59,98.59,0,0,0,7.89,13.22,99.28,99.28,0,0,1-7.56-11.48c-4.77-8-9.28-15.58-15.57-16.16-3.3-.3-6.76,1.32-10.54,5C74.48,20.09,71.7,26.55,69,32.8,65.65,40.62,62.47,48,56.54,48.36c-4.07.26-7.92-5.54-12-11.67-1.7-2.57-3.44-5.18-5.26-7.5,1.6,1.87,3.12,3.89,4.57,5.83m-6.06-8.7A72.61,72.61,0,0,1,44.07,33c4.11,4.77,7.67,8.88,11.83,8.6,5.87-.39,10.33-8.51,15.05-17.1,3.62-6.59,7.37-13.41,11.86-17C85.94,5,88.68,4,91.19,4.44c5.91,1,9.94,9.57,14.21,18.68a117.69,117.69,0,0,0,6.83,13.14A119.31,119.31,0,0,1,105.7,24.9c-4.57-8.65-8.88-16.82-15.24-17.62-3.08-.39-6.32,1-9.9,4.09-4.55,4-7.82,10.63-11,17-4,8.14-7.78,15.83-13.4,16.19-3.82.24-7.53-4.7-11.45-9.94a74.31,74.31,0,0,0-6.9-8.34m6.46,4.54c4,3.87,7.37,7.22,11.26,7,5.52-.39,10.55-8.72,15.89-17.52,4.13-6.84,8.41-13.9,12.9-17.12,3-2,5.52-2.78,7.87-2.3,6.06,1.24,9.89,10.5,13.94,20.3a132.4,132.4,0,0,0,6.2,13.55c-2.17-3.62-4.11-7.76-6-11.85C102,13.56,97.84,4.76,91.4,3.72c-2.87-.46-5.9.61-9.28,3.28-4.62,3.64-8.4,10.52-12.06,17.18-4.6,8.38-9,16.3-14.23,16.65-3.58.25-7.16-3.89-10.94-8.27a55.82,55.82,0,0,0-8.22-8.26,54.07,54.07,0,0,1,7.61,6.56M88.8,14.23c-3.57-.22-7.28,1.7-11.35,5.87-4.42,4.75-6.83,11.31-9,17.1C65.63,45,63.15,51.76,56.9,52.12c-4.34.26-8.3-6.4-12.49-13.45-1.29-2.15-2.58-4.33-3.92-6.37,1.11,1.56,2.17,3.17,3.2,4.72,4.29,6.47,8,12.08,12.58,12.08h.34c6.57-.4,9.7-7.66,13.32-16.06,2.66-6.19,5.42-12.59,9.83-16.84,3.56-3.44,6.73-5,9.67-4.7,5.75.52,10.15,7.91,14.8,15.73a87.49,87.49,0,0,0,8.49,12.58,88.46,88.46,0,0,1-8-10.78c-5-7.4-9.62-14.4-15.92-14.79",
    transform: "translate(0 0)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlankton);
export default __webpack_public_path__ + "static/media/LogoPlankton.ac6656bb89fca21e26804148b056c5ce.svg";
export { ForwardRef as ReactComponent };